import { Divider } from 'antd';
import React, { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';

import { Modal } from '@/shared/ui';

import { Loader } from '@/shared/ui';

import { GroupedNotifications } from '../model';

import { NotificationsDateGroup } from './NotificationsDateGroup';

import './NotificationsStyles.scss';

interface Props {
  isOpen: boolean;
  isLoading: boolean;
  groupedNotifications: GroupedNotifications[];
  toggleModal: VoidFunction;
  loadMore: VoidFunction;
  hasMore: boolean;
}

export const NotificationsModal = React.memo<Props>(
  ({ isOpen, isLoading, groupedNotifications, toggleModal, loadMore, hasMore }) => {
    const scrollRef = useRef<HTMLDivElement | null>(null);

    const { ref: loadMoreRef, inView } = useInView({
      threshold: 0,
    });

    useEffect(() => {
      if (inView && !isLoading) {
        loadMore();
      }
    }, [inView, isLoading, loadMore]);

    return (
      <>
        <Modal
          title="Нотифікації"
          titleTypographyVariant="H3"
          onCancel={toggleModal}
          open={isOpen}
          centered={false}
          className="notifications__modal"
          forceRender
          closable
        >
          <Divider className="notifications__divider" />

          <div className="notifications__scrollable-body" ref={scrollRef}>
            {groupedNotifications.map(({ date, notifications }) => (
              <NotificationsDateGroup
                key={date}
                date={date}
                notifications={notifications}
                toggleNotificationsModal={toggleModal}
              />
            ))}
            {hasMore && <div ref={loadMoreRef} className="notifications__empty-div" />}
            {isLoading && <Loader />}
          </div>
        </Modal>
      </>
    );
  },
);
